import React from 'react'

import Layout from '../../../../components/Layout'
import Text from '../../../../components/Text'
import Stepper from '../../../../components/Stepper'
import Documents from '../../../../components/care-plans/UploadDocuments'
import AddressSelector from '../../../../components/AddressSelector'
import AddressBottomSheet from '../../../../components/BottomSheet/AddressBottomSheet'

import ArrowLeftIcon from '../../../../components/Icons/ArrowLeft'

import useLiverForeverJourneyHook from './useLiverForeverJourney.hook'

const LiverForeverJourneyPage = () => {
  const {
    steps,
    activeStep,
    supportProgram,
    showAddressBottomSheet,
    address,
    handleBackButtonClick,
    handleProceedClick,
    onAddressSelect,
    setShowAddressBottomSheet,
  } = useLiverForeverJourneyHook()

  const renderActiveStepScreen = (activeStep) => {
    switch (activeStep?.id) {
      case 'documents':
        return (
          <Documents
            data={activeStep}
            handleProceedClick={handleProceedClick}
          />
        )
      case 'address':
        return (
          <AddressSelector
            onAddressSelect={onAddressSelect}
            onBack={handleBackButtonClick}
          />
        )
    }
  }

  return (
    <Layout className="bg-white">
      <div className="min-w-sm max-w-lg relative mx-auto w-full h-screen bg-[#F2F4F7]">
        <div className="border-b border-gray-200 bg-white px-4 py-3 flex flex-col gap-3">
          <div className="flex items-center gap-2">
            <button onClick={handleBackButtonClick}>
              <ArrowLeftIcon />
            </button>
            <Text variant="body" size="large" tag="label" className="font-bold">
              {supportProgram?.name}
            </Text>
          </div>
          {steps?.length > 1 && (
            <Stepper steps={steps.length} currentStep={activeStep} />
          )}
        </div>

        <div
          className="overflow-y-auto"
          style={{
            height: `calc(100% - ${steps?.length === 1 ? '40px' : '93px'})`,
          }}
        >
          {renderActiveStepScreen(steps[activeStep - 1])}
        </div>
      </div>

      <AddressBottomSheet
        show={showAddressBottomSheet}
        address={address}
        onClose={() => setShowAddressBottomSheet(false)}
        onProceed={() => {
          setShowAddressBottomSheet(false)
          handleProceedClick()
        }}
      />
    </Layout>
  )
}

export default LiverForeverJourneyPage
